import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Block.css';

class Block extends React.Component {

  static propTypes = {
    disabled: PropTypes.bool,
    children: PropTypes.any,
  }

  render() {
    const { disabled, children } = this.props;

    return (
      <div name="Block" className={classNames({ disabled })}>
        {children}
        { disabled ? (
          <div className="curtain" />
        ) : null }
      </div>
    );
  }

}

export default Block;
